import { defineRecipe, defineParts } from "@pandacss/dev";

const parts = defineParts({
  itemGroup: {
    selector: '& [data-part="item-group"]',
  },
  itemGroupLabel: {
    selector: '& [data-part="item-group-label"]',
  },
  item: {
    selector: '& [data-part="item"]',
  },
  content: {
    selector: '& [data-part="content"]',
  },
  iconPrimary: {
    selector: '& [data-part="icon-primary"]',
  },
  iconSecondary: {
    selector: '& [data-part="icon-secondary"]',
  },
});

export const aromaNavMenu = defineRecipe({
  className: "aroma-nav-menu",
  jsx: ["NavMenu"],
  base: parts({
    itemGroup: {
      py: "padding.2",
      px: "padding.3",
      mx: "-padding.3",
      borderBottomWidth: "m",
      borderBottomStyle: "solid",
      borderBottomColor: "border.neutral.subtle",
      maxHeight: "296px",
      overflow: "auto",
      _first: {
        pt: "0",
      },
      _last: {
        pb: "0",
        borderBottom: "none",
      },
    },
    itemGroupLabel: {
      textTransform: "uppercase",
      fontWeight: "bold",
      fontSize: "75",
      color: "content.neutral.base.subtle",
      py: "10px",
      px: "padding.2",
    },
    item: {
      width: "width.2xs",
      fontWeight: "bold",
      fontSize: "88",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: "padding.1,5",
      pr: "padding.3",
      minHeight: "{sizes.xl}",
      cursor: "pointer",
      borderRadius: "l",
      borderColor: "transparent",
      '&:has([data-part="icon-primary"])': {
        py: "padding.1,5",
      },
      '&:has([data-part="icon-secondary"])': {
        py: "padding.1",
      },
      _hover: {
        bgColor: "background.neutral.base.subtlest-hover",
        '& [data-part="icon-primary"]': {
          color: "content.neutral.reverse.bold",
          backgroundColor: "background.brand.bold",
        },
      },
      _focus: {
        outlineColor: "border.brand-bold",
        outlineWidth: "m",
        outlineStyle: "solid",
        outlineOffset: "-1px",
        shadow: "effect.focus-ring.brand",
        shadowColor: "focus-ring.brand",
        "& [data-part='icon-primary']": {
          color: "content.brand.bold",
        },
      },
      _active: {
        color: "content.brand.bold",
        "& [data-part='icon-primary']": {
          backgroundColor: "background.brand.bold",
          color: "content.neutral.reverse.bold",
        },
        "& [data-part='icon-secondary']": {
          backgroundColor: "background.brand.subtle",
          color: "content.brand.bold",
        },
      },
      _disabled: {
        textStyle: "title.s",
        color: "content.neutral.base.disable",
        cursor: "not-allowed",
        backgroundColor: "transparent",
        "& [data-part='icon-primary']": {
          backgroundColor: "background.neutral.disable.subtle !important",
          color: "content.neutral.base.disable !important",
        },
        "& [data-part='icon-secondary']": {
          backgroundColor: "transparent !important",
          color: "content.neutral.base.disable !important",
        },
      },
    },
    content: {
      py: "padding.4",
      px: "padding.3",
      marginLeft: "margin.4",
      shadow: "effect.shadow.bolder-bottom",
      background: "background.neutral.base.subtlest",
      borderRadius: "l",
      gap: "gap.1",
      _focusVisible: {
        outline: "none",
      },
    },
    iconPrimary: {
      fontSize: "100 !important",
      color: "content.brand.bold",
      backgroundColor: "background.brand.subtle",
      padding: "padding.2",
      borderRadius: "xl",
    },
    iconSecondary: {
      fontSize: "125 !important",
      padding: "padding.1,5",
      borderRadius: "m",
    },
  }),
});
